module.exports = __webpack_public_path__ + "img/question-mark-circle.ef1e8bc3.svg";